module.exports = __webpack_public_path__ + "71ab7c5b5ad6e2d6d9dadacc1ee0f43c.png";